module.exports = __webpack_public_path__ + "static/media/mom.849b11d9.jpeg";